import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Suspense } from 'react'
import { ProtectedRoute } from '@njnorge/admin-common'
import BasicLayout from './layouts/BasicLayout'
import Login from './pages/login'
import { routeConfig, flattenRoutes } from './config/routes'

const PageLoader = () => (
  <div className="page-loader">
    <div className="page-loader-pulse" />
  </div>
)

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* 受保护路由 */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<BasicLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />

              {/* 动态注册所有扁平化路由 */}
              {flattenRoutes(routeConfig).map(({ path, component: Component }) =>
                Component ? (
                  <Route
                    key={path}
                    path={path.startsWith('/') ? path.slice(1) : path}
                    element={<Component />}
                  />
                ) : null,
              )}

              {/* 历史旧路由透明兼容重定向 */}
              <Route path="merchant-audit" element={<Navigate to="/stores/audit" replace />} />
              <Route path="store-audit" element={<Navigate to="/stores/audit" replace />} />
              <Route path="merchant-list" element={<Navigate to="/stores/list" replace />} />
              <Route path="store-list" element={<Navigate to="/stores/list" replace />} />
              <Route path="order-supervision" element={<Navigate to="/orders/supervision" replace />} />
              <Route path="user-management" element={<Navigate to="/platform/users" replace />} />

              {/* 404 回退至 Dashboard */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
